import { definePuzzle } from './PuzzleDefinition';
// Exact official CC0 example records from https://database.lichess.org/#puzzles, retrieved 2026-09-21.
export const officialRows = [
  [
    '00sHx',
    'q3k1nr/1pp1nQpp/3p4/1P2p3/4P3/B1PP1b2/B5PP/5K2 b k - 0 17',
    'e8d7 a2e6 d7d8 f7f8',
    1760,
    80,
    83,
    72,
    'mate mateIn2 middlegame short',
    'https://lichess.org/yyznGmXs/black#34',
    'Italian_Game Italian_Game_Classical_Variation',
  ],
  [
    '00sJ9',
    'r3r1k1/p4ppp/2p2n2/1p6/3P1qb1/2NQR3/PPB2PP1/R1B3K1 w - - 5 18',
    'e3g3 e8e1 g1h2 e1c1 a1c1 f4h6 h2g1 h6c1',
    2671,
    105,
    87,
    325,
    'advantage attraction fork middlegame sacrifice veryLong',
    'https://lichess.org/gyFeQsOE#35',
    'French_Defense French_Defense_Exchange_Variation',
  ],
  [
    '00sJb',
    'Q1b2r1k/p2np2p/5bp1/q7/5P2/4B3/PPP3PP/2KR1B1R w - - 1 17',
    'd1d7 a5e1 d7d1 e1e3 c1b1 e3b6',
    2235,
    76,
    97,
    64,
    'advantage fork long',
    'https://lichess.org/kiuvTFoE#33',
    'Sicilian_Defense Sicilian_Defense_Dragon_Variation',
  ],
  [
    '00sO1',
    '1k1r4/pp3pp1/2p1p3/4b3/P3n1P1/8/KPP2PN1/3rBR1R b - - 2 31',
    'b8c7 e1a5 b7b6 f1d1',
    998,
    85,
    94,
    293,
    'advantage discoveredAttack master middlegame short',
    'https://lichess.org/vsfFkG0s/black#62',
    '',
  ],
] as const;
export const fixtures = officialRows.map((r) =>
  definePuzzle({
    id: r[0],
    fenBefore: r[1],
    setupMove: r[2].split(' ')[0],
    solutionMoves: r[2].split(' ').slice(1),
    rating: r[3],
    ratingDeviation: r[4],
    popularity: r[5],
    playCount: r[6],
    themes: r[7].split(' '),
    sourceGameUrl: r[8],
    openingTags: r[9].split(' ').filter(Boolean),
    datasetVersion: 'official-examples-2026-09-21',
  }),
);
export function synthetic(id: string, fen: string, moves: string, themes: string[] = []) {
  const [setupMove, ...solutionMoves] = moves.split(' ');
  return definePuzzle({
    id,
    fenBefore: fen,
    setupMove,
    solutionMoves,
    rating: 1200,
    ratingDeviation: 50,
    popularity: 95,
    playCount: 100,
    themes,
    sourceGameUrl: '',
    openingTags: [],
    datasetVersion: 'synthetic-test-only',
  });
}
